import api from './client';

export interface Attachment {
  name: string;
  url: string;      // base64 data
  size: number;
  mimeType: string;
}

export interface AssignedTask {
  id: string;
  title: string;
  description?: string;
  creatorId: string;
  creatorName: string;
  assigneeId: string;
  assigneeName: string;
  observers: { id: string; name: string }[];
  dueDate: string;
  status: 'new' | 'in_progress' | 'pending_review' | 'completed' | 'rejected' | 'revision';
  attachments: Attachment[];
  completionComment?: string;
  reviewComment?: string;
  createdAt: string;
  updatedAt: string;
}

export const assignedTasksApi = {
  getTasks: (params?: { assigneeId?: string; creatorId?: string; dueDate?: string; status?: string }) =>
    api.get('/assigned-tasks', { params }),
  getTask: (id: string) => api.get(`/assigned-tasks/${id}`),
  createTask: (data: any) => api.post('/assigned-tasks', data),
  updateTask: (id: string, data: any) => api.put(`/assigned-tasks/${id}`, data),
  deleteTask: (id: string) => api.delete(`/assigned-tasks/${id}`),
  getStats: () => api.get('/assigned-tasks/stats'),
};